import { PaginatedResult } from '../../models/paginatedResult';
import { client } from '../client';

export class SubEntityRequestService<T> 
{
    serviceName: string;
    getBaseRoute: (baseId: string| number)=>string;

    constructor(baseEntity: string, subEntity: string) {
        this.serviceName = `${baseEntity}/${subEntity}`;
        this.getBaseRoute =  (baseId: string| number)=>`${baseEntity}/${baseId}/${subEntity}`;
      }
   
    fetch = async (baseId: string | number, pageUrl?: string) => client.get<PaginatedResult<T>>(pageUrl ?? this.getBaseRoute(baseId));
    create = async (baseId: string | number, item: T) => client.post<T>(this.getBaseRoute(baseId), item);
    update = async (baseId: string | number, id: number, item: T) => client.post<T>(`${this.getBaseRoute(baseId)}/${id}`, item);
    create_multiple = async (baseId: string | number, list: T[]) => client.post<PaginatedResult<T>>(`${this.getBaseRoute(baseId)}/multiple`, list);
    delete = async (baseId: string | number, itemId: number) => client.delete<void>(`${this.getBaseRoute(baseId)}/${itemId}`);
    init = async (baseId: string | number) => client.get<T>(`${this.getBaseRoute(baseId)}/init`);
}

